export default __webpack_public_path__ + "static/media/Left-Photo-Brand.ae67b57e.jpg";